import * as Yup from "yup";

export const addAdminValidation = Yup.object().shape({
  email: Yup.string()
    .required("email is required")
    .email("Must be a valid email"),
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last Name is required"),
  phoneNo: Yup.string()
    .required("phone number is required")
    .length(11, "Phone number must be 11 digits"),
});

export type adminValidationForm = Yup.InferType<typeof addAdminValidation>;
